export default class Output {

    static availableOptions = [];

    /**
     *
     * @param subject Subject can be a Palette, Color, or String
     * @param decorator is another Output with a output()
     */
    constructor(subject, decorator = null) {
        this.subject = subject;
        this.decorator = decorator;
    }

    output() {
        // Implemented by subclasses
    }

}